import React from "react";
import axios from "axios";
import MsgDisplay from "./MsgDisplay";

const AppliedAndAllottedTable = ({
  appliedSgbData,
  setCancelModalFlag,
  setCancelModalData,
  errormsg,
}) => {
  const handleCancelButton = (item) => {
    debugger;
    setCancelModalFlag(true);
    setCancelModalData(item);
  };
  const Qty = (price, qty) => {
    if (price && qty) {
      return price * qty;
    } else {
      return "Not available";
    }
  };
  return (
    <div class="col-lg-12 col-xs-12">
      <div class="scroll_data">
        <table class="tbl_web">
          <thead>
            <tr>
              <th>SGB Name</th>
              <th>Interest till Maturity(per annum)</th>
              <th>Interest Interval</th>
              <th>Close Date</th>
              <th>Last Action Date</th>
              <th>QTY</th>
              <th>Rate</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Order Number</th>
              <th>Trade Number</th>
              <th>Cancel</th>
            </tr>
          </thead>
          <tbody>
            {!errormsg ? (
              Array.isArray(appliedSgbData) && appliedSgbData.length > 0 ? (
                appliedSgbData.map((item, index) => (
                  <tr key={index}>
                    <td align="center">{item.NAME}</td>
                    <td align="center">{item.INTERESTRATE}%</td>
                    <td align="center">ANNUALLY</td>
                    <td align="center">{item.BIDDINGENDDATE}</td>
                    <td align="center">{item.LASTACTIONTIME}</td>
                    <td align="center">{item.QUANTITY}</td>
                    <td align="center">{item.PRICE}</td>
                    <td align="center">{Qty(item.PRICE, item.QUANTITY)}</td>
                    <td align="center">{item.STATUS}</td>
                    <td align="center">{item.ORDERNUMBER}</td>
                    <td align="center">{item.APPLICATIONNO}</td>
                    <td align="center">
                      {/* test condition */}
                      {item.STATUS != "FAILED" &&
                        item.ORDERSTATUS != "CS" &&
                        item.CANCELFLAG == "Y" && (
                          <button
                            className="cancel_btn cancel_click "
                            onClick={() => {
                              handleCancelButton(item);
                            }}
                          >
                            Cancel
                          </button>
                        )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="12">No data available</td>
                </tr>
              )
            ) : (
              <MsgDisplay />
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AppliedAndAllottedTable;
